import { render, staticRenderFns } from "./ServiceReg.vue?vue&type=template&id=429a0745&scoped=true"
import script from "./ServiceReg.vue?vue&type=script&lang=js"
export * from "./ServiceReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a0745",
  null
  
)

export default component.exports